module.exports = __webpack_public_path__ + "img/access_analysis.bb00e07d.png";